import React, { useEffect } from 'react';
import {Form, Formik} from 'formik';
import * as Yup from 'yup';
import {FormInput} from '../../../../../../components/shared/form-controls/form-input';
import {FormCheckbox} from '../../../../../../components/shared/form-controls/form-checkbox';
import {useAppDispatch, useAppSelector} from '../../../../../../hooks/hooks';
import {addShiftType} from '../../../../../../features/types';
import {TiminatorType} from '../../../../../../features/types/types';
import { useIntl } from 'react-intl';
import { Lx } from '../../../../../../i18n/consts';
import BaseForm from '../../../../../../components/shared/form-controls/base-form';
import { useNavigate } from 'react-router-dom';
import { NAVIGATION_ROUTES } from '../../../../../../routes/NavigationRoute';
import { canManageShiftTypes } from '../../../../../../features/profile/entityPermissions';

interface CreateForm {
    name: string;
    isDefault: boolean;
    isActive: boolean;
}

export default function ShiftTypeCreateForm() {
    const dispatch = useAppDispatch();
    const intl = useIntl();

    const navigate = useNavigate();
    const profile = useAppSelector(store => store.profile);
    const canEditShiftTypes = canManageShiftTypes(profile);

    useEffect(() => {
        if (!canEditShiftTypes) {
            navigate(NAVIGATION_ROUTES.SHIFT_TYPES);
        }
    }, [canEditShiftTypes, navigate]);

    if (!canEditShiftTypes) {
        return null;
    }

    const initialValue: CreateForm = {
        name: '',
        isDefault: false,
        isActive: true,
    };

    const validationScheme: Yup.Schema<CreateForm> = Yup.object({
        name: Yup.string()
            .max(45, 'Must be 45 characters or less')
            .required(intl.formatMessage({ id: Lx.Form.NAME_REQUIRED_FORMAT }, { s: intl.formatMessage({ id: Lx.General.PROJECT_TYPE }) })),
        isDefault: Yup.boolean().required(),
        isActive: Yup.boolean().required(),
    })

    const save = async (values: CreateForm) => {
        const type: TiminatorType = {
            id: 0,
            name: values.name,
            active: values.isActive,
            default: values.isDefault,
        }
        return dispatch(addShiftType(type));
    }

    return <Formik
        initialValues={initialValue}
        validationSchema={validationScheme}
        validateOnBlur={true}
        validateOnChange={true}
        onSubmit={save}>
        <Form>
            <BaseForm contentGap={24}
                formType='create'
                formHeader='create_shift_type'
                elementName=''
                savingTitle='Shift type' 
                onClose={() => navigate(NAVIGATION_ROUTES.SHIFT_TYPES)} 
                onAfterSave={() => navigate(NAVIGATION_ROUTES.SHIFT_TYPES)}>
                <FormInput name='name' label='Name' placeholder='Shift type' />
                <fieldset>
                    <FormCheckbox name='isDefault' label='Default' />
                    <FormCheckbox name='isActive' label='Active'/>
                </fieldset>
            </BaseForm>
        </Form>
    </Formik>
}
